var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 3.33332C14.6083 3.33332 14.9958 3.33332 15.3137 3.41851C16.1765 3.64968 16.8503 4.32355 17.0815 5.18628C17.1667 5.50419 17.1667 5.89168 17.1667 6.66666V14.3333C17.1667 15.7335 17.1667 16.4335 16.8942 16.9683C16.6545 17.4387 16.2721 17.8212 15.8017 18.0608C15.2669 18.3333 14.5668 18.3333 13.1667 18.3333H7.83334C6.43321 18.3333 5.73315 18.3333 5.19837 18.0608C4.72796 17.8212 4.34551 17.4387 4.10583 16.9683C3.83334 16.4335 3.83334 15.7335 3.83334 14.3333V6.66666C3.83334 5.89168 3.83334 5.50419 3.91853 5.18628C4.1497 4.32355 4.82357 3.64968 5.6863 3.41851C6.00421 3.33332 6.3917 3.33332 7.16668 3.33332M8.50001 4.99999H12.5C12.9667 4.99999 13.2001 4.99999 13.3783 4.90916C13.5351 4.82927 13.6626 4.70178 13.7425 4.54498C13.8333 4.36672 13.8333 4.13337 13.8333 3.66666V2.99999C13.8333 2.53328 13.8333 2.29992 13.7425 2.12166C13.6626 1.96486 13.5351 1.83738 13.3783 1.75748C13.2001 1.66666 12.9667 1.66666 12.5 1.66666H8.50001C8.0333 1.66666 7.79994 1.66666 7.62168 1.75748C7.46488 1.83738 7.3374 1.96486 7.2575 2.12166C7.16668 2.29992 7.16668 2.53328 7.16668 2.99999V3.66666C7.16668 4.13337 7.16668 4.36672 7.2575 4.54498C7.3374 4.70178 7.46488 4.82927 7.62168 4.90916C7.79994 4.99999 8.0333 4.99999 8.50001 4.99999Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.a50f7e099359957d65c9d02529cdb75e.svg";
export { ForwardRef as ReactComponent };